import React from "react";
import { StyleSheet, Text, View } from "react-native";
import Icon from "react-native-vector-icons/Ionicons";

export default function Info({ data }) {
  return (
    <View style={styles.viewPrincipal}>
      <View>
        {data.map((item, index) =>
          !(index % 2) ? (
            <View key={index + item} style={styles.viewInfo}>
              <Icon name={"information-circle-outline"} size={25} />
              <Text style={styles.textInfo}>{item}</Text>
            </View>
          ) : null
        )}
      </View>
      <View>
        {data.map((item, index) =>
          index % 2 ? (
            <View key={index + item} style={styles.viewInfo}>
              <Icon name={"information-circle-outline"} size={25} />
              <Text style={styles.textInfo}>{item}</Text>
            </View>
          ) : null
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  viewPrincipal: {
    justifyContent: "space-between",
  },
  textInfo: {
    margin: 4,
    width: "90%",
  },
  viewInfo: {
    flexDirection: "row",
    margin: 2,
    alignItems: "center",
  },
});
